<template>
  <div class="v2-badge" :class="theme">
    <i :class="`icon icon-${icon}`" />
  </div>
</template>

<script setup lang="ts">
defineOptions({
  name: "badge",
});

defineProps({
  theme: {
    type: String,
    require: false,
    default: "middle-pink",
    validator: (value: string) => {
      return ["middle-pink", "peach", "orange", "light-pink", "light"].includes(value);
    },
  },
  icon: {
    type: String,
    require: true,
    default: null,
  },
});
</script>

<style lang="scss">
@import "./index.scss";
</style>
